import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {Observable} from 'rxjs';
import {TisaMediaLibraryHttpService} from '../tisa-media-library-http.service';
import {MediaLibraryFile} from '@tisa-group/models';
import {HttpEvent} from '@angular/common/http';

export interface SerializedMediaLibraryFile {
  id: string;
  type: string;
  attributes: {
    url: string;
  };
}

@Injectable()
export class FileService implements CrudService<MediaLibraryFile> {
  readonly endpoint = '/uploads/files';

  constructor(readonly http: TisaMediaLibraryHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<MediaLibraryFile[]>> {
    return this.http
      .get(this.endpoint, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  upload(
    file: File,
    path = '/',
    params?: JsonApiParams,
  ): Observable<HttpEvent<SerializedMediaLibraryFile>> {
    const formData = new FormData();

    formData.append('path', path);
    formData.append('file', file);

    return this.http.post(this.endpoint, formData, {
      params: objectToHttpParams(params),
      reportProgress: true,
      observe: 'events',
    });
  }

  update(
    body: Partial<MediaLibraryFile>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<MediaLibraryFile>> {
    return this.http
      .patch(`${this.endpoint}/${body.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`${this.endpoint}/${id}`);
  }
}
